import type { UseSuggestionsListWidth } from 'lib-knowledge-management';
import { useCallback } from 'react';

import { useServerStorage } from 'utils/useServerStorage';

/**
 * The width the user dragged the AI article suggestions list to, remembered in
 * the user's server storage like the conversations split view's size.
 */
export const useSuggestionsListWidth: UseSuggestionsListWidth = () => {
  const { data, set } = useServerStorage('user');

  const setWidth = useCallback(
    (width: number) =>
      set({
        knowledge: (draft) => {
          draft.suggestionsListWidth = width;
        },
      }),
    [set],
  );

  return [data.knowledge?.suggestionsListWidth, setWidth];
};
